import { toast } from 'sonner';
import type { IntegrityCheckResult } from '../../types/index';

export async function triggerAutoCleanup(institutionId: string, checks: IntegrityCheckResult[]) {
  const fixableIssues = (checks || []).filter(c => c.auto_fixable && c.status !== 'PASS');
  if (fixableIssues.length === 0) return;

  try {
    const { useAuthStore } = await import('@/stores/authStore');
    const user = useAuthStore.getState().user;
    if (!user?.id) return;

    // Import and use cleanup utilities
    const { cleanupOrphanedData } = await import('../../utils/data-integrity');
    const result = await cleanupOrphanedData(user.id);

    if ((result as any)?.success) {
      toast.success('Data Cleaned', {
        description: `Cleaned ${(result as any)?.cleaned?.holdings || 0} orphaned holdings`,
        duration: 4000
      });
    }
  } catch (error) {
    console.error('❌ INTEGRITY: Auto-cleanup failed', { institutionId, error });
  }
}
